import React from 'react';
import {Row, Col, Card} from 'react-materialize';

import what_is_sars from '../../images/what_is_sars.png';
import symptoms from '../../images/symptoms.png';
import transmission from '../../images/transmission.png';
import protection from '../../images/protection_covid19.png';
import mask from '../../images/mask_covid19.png';
import other_protection from '../../images/other_protection.png';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"covid.header"} defaultMessage={"COVID-19"}/></b></p></h5>
            </div>
        </Row>

        <Row align="center">
            <div style={{display: 'inline-flex', alignItems: 'center', margin:"10px"}}>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/what_is_sars"} style={{background:'white', color: 'black'}}>
                        <img src={what_is_sars} className={"img"} alt={"O que é SARS-COV-2?"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"what_is_sars_title"} defaultMessage={"O que é SARS-COV-2?"}/></b></p>
                    </a>
                </div>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/symptoms"} style={{background:'white', color: 'black'}}>
                        <img src={symptoms} className={"img"} alt={"Sintomas"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"symptoms_title"} defaultMessage={"Sintomas"}/></b></p>
                    </a>
                </div>
            </div>
        </Row>

        <Row align="center">
            <div style={{display: 'inline-flex', alignItems: 'center', margin:"10px"}}>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/transmission"} style={{background:'white', color: 'black'}}>
                        <img src={transmission} className={"img"} alt={"Transmissao"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"transmission_title"} defaultMessage={"Transmissão"}/></b></p>
                    </a>
                </div>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/protection"} style={{background:'white', color: 'black'}}>
                        <img src={protection} className={"img"} alt={"Proteção"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"protection_title"} defaultMessage={"Proteção"}/></b></p>
                    </a>
                </div>
            </div>
        </Row>

        <Row align="center">
            <div style={{display: 'inline-flex', alignItems: 'center', margin:"10px"}}>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/masks"} style={{background:'white', color: 'black'}}>
                        <img src={mask} className={"img"} alt={"Mascaras"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"masks_title"} defaultMessage={"O que você deve saber sobre máscaras"}/></b></p>
                    </a>
                </div>
                <div align="center" style={{margin:"20px", height:"100px", width:"120px"}}>
                    <a href={"/other_protection"} style={{background:'white', color: 'black'}}>
                        <img src={other_protection} className={"img"} alt={"Outras proteções"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"other_protection_title"} defaultMessage={"Outras medidas de proteção"}/></b></p>
                    </a>
                </div>
            </div>
        </Row>

    </Card>

);

export default Sobre;